import { render, staticRenderFns } from "./grade-card.vue?vue&type=template&id=14acc418&scoped=true&"
import script from "./grade-card.ts?vue&type=script&lang=ts&"
export * from "./grade-card.ts?vue&type=script&lang=ts&"
import style0 from "./grade-card.scss?vue&type=style&index=0&id=14acc418&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14acc418",
  null
  
)

export default component.exports